export default "__VITE_ASSET__BUrWrOcL__"